import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faInstagram, faTiktok } from '@fortawesome/free-brands-svg-icons';
import './Footer.css';

const Footer: React.FC = () => {
	return (
		<footer className="footer">
			<div className="container">
				<div className="footer-content">
					<div className="footer-section">
						<h3>The G.O.A.T. Grazers</h3>
						<p>Land clearing with goats in East Tennessee!</p>
					</div>

					<div className="footer-section">
						<h3>Quick Links</h3>
						<ul className="footer-links">
							<li><Link to="/">Home</Link></li>
							{/* <li><Link to="/story">Our Story</Link></li>
							<li><Link to="/services">Services</Link></li>
							<li><Link to="/faq">FAQ</Link></li>
							<li><Link to="/team">Meet the Herd</Link></li> */}
							<li><Link to="/contact">Contact</Link></li>
						</ul>
					</div>

					<div className="footer-section">
						<h3>Follow our herd!</h3>
						<p></p>
						<div className="social-links">
							<a href="https://www.facebook.com/share/16kRw8soJC" target="_blank" rel="noreferrer" className="social-link" aria-label="Facebook">
								<FontAwesomeIcon icon={faFacebook} />
							</a>
							<a href="https://www.instagram.com/the_goat_grazers" target="_blank" rel="noreferrer" className="social-link" aria-label="Instagram">
								<FontAwesomeIcon icon={faInstagram} />
							</a>
							<a href="https://www.tiktok.com/@thegoatgrazers" target="_blank" rel="noreferrer" className="social-link" aria-label="TikTok">
								<FontAwesomeIcon icon={faTiktok} />
							</a>
						</div>
					</div>
				</div>

				<div className="footer-bottom">
					<p>&copy; {new Date().getFullYear()} The G.O.A.T. Grazers. All Rights Reserved.</p>
				</div>
			</div>
		</footer>
	);
};

export default Footer;

